import React from "react";

const QuoteFormPanel = ({
  title,
  actionLabel,
  actionIcon,
  actionCount,
  onAction,
  tabs,
  activeTab,
  onTabChange,
  rightActions,
  hideHeader = false,
  children,
}) => (
  <div className={`card quote-form-panel${hideHeader ? " quote-form-panel--focused" : ""}`}>
    {!hideHeader && (
      <div className="quote-form-panel-header">
        {tabs?.length > 0 ? (
          <div className="quote-form-tabs" role="tablist" aria-label="Quote sections">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  type="button"
                  className={`quote-form-tab-btn ${isActive ? "active" : ""}`}
                  onClick={() => onTabChange?.(tab.key)}
                  role="tab"
                  aria-selected={isActive}
                >
                  {tab.icon && <i className={tab.icon}></i>}
                  <span>{tab.label}</span>
                  {Number(tab.count) > 0 && <strong>{tab.count}</strong>}
                </button>
              );
            })}
          </div>
        ) : (
          <h2>{title}</h2>
        )}
        <div className="quote-form-header-actions">
          {rightActions}
          {actionLabel && (
            <button type="button" className="btn quote-form-panel-action" onClick={onAction}>
              {actionIcon && <i className={actionIcon}></i>}
              <span>{actionLabel}</span>
              {Number(actionCount) > 0 && <strong>{actionCount}</strong>}
              <i className="fas fa-chevron-right"></i>
            </button>
          )}
        </div>
      </div>
    )}
    <div className="card-body">{children}</div>
  </div>
);

export default React.memo(QuoteFormPanel);
